import { ARISE_DOMAIN_REFG, ARISE_DOMAIN, FILE_EXTENSION_EXCLUDE_RESIZE_REG, GW_CDN_DOMAIN, IMG_ALICDN_DOMAIN, FB_ES_DOMAIN, GCP_OSS_DOMAIN, LONG_OSS_DOMAIN, AE_CDN_DOMAIN_REG, SG_LIVE_CDN_REG, LZD_CDN_DOMAIN, LZD_MY_CDN_DOMAIN_REG, LZD_UGC_ACCELERATE_OSS_DOMAIN, LZD_UGC_OSS_DOMAIN } from "./config";
import { isSupportWebp, isSupportAvif } from './utils/format';
import getSize from './utils/size';
import getQuality from './utils/quality';
import getSharpen from './utils/sharpen';
import getUrl from './utils/url';

/**
 * rewrite url
 * @param {string} url start with 'https://' or 'http://' or '//'
 * @returns {string}
 */
function urlRewrite(url) {
  if (!url) return url;
  url = url.trim();
  var originalUrl = null;
  if (url.startsWith('http')) {
    originalUrl = url;
  } else if (url.startsWith('//')) {
    originalUrl = "https:" + url;
  }
  if (!originalUrl) return url;
  if (ARISE_DOMAIN_REFG.test(originalUrl)) return url;
  try {
    var formatUrl = new URL(originalUrl);
    var targetPath = '';
    var hostname = formatUrl.hostname,
      pathname = formatUrl.pathname;
    if (pathname === '/') return url;
    if (GW_CDN_DOMAIN === hostname || IMG_ALICDN_DOMAIN === hostname) {
      targetPath = 'g/tps' + pathname;
    } else if (FB_ES_DOMAIN === hostname) {
      targetPath = 'g/fb' + pathname;
    } else if (GCP_OSS_DOMAIN === hostname) {
      targetPath = 'gcp' + pathname;
    } else if (LONG_OSS_DOMAIN === hostname) {
      targetPath = 'g/long' + pathname.replace('/arise-longimg', '');
    } else if (AE_CDN_DOMAIN_REG.test(hostname)) {
      targetPath = 'g/ae' + pathname;
    } else if (SG_LIVE_CDN_REG.test(hostname)) {
      targetPath = 'live/sg' + pathname;
    } else if (LZD_CDN_DOMAIN === hostname || LZD_UGC_ACCELERATE_OSS_DOMAIN === hostname || LZD_UGC_OSS_DOMAIN === hostname) {
      targetPath = 'g/ugc' + pathname;
    } else if (LZD_MY_CDN_DOMAIN_REG.test(hostname)) {
      targetPath = 'live/my' + pathname;
    } else {
      return url;
    }
    return ARISE_DOMAIN + targetPath;
  } catch (e) {
    console.warn('url rewrite error ->', e);
  }
  return url;
}
function getResizeUrl(url, width, height, config) {
  if (width === void 0) {
    width = 0;
  }
  if (height === void 0) {
    height = 0;
  }
  if (config === void 0) {
    config = {};
  }
  // global config , use for setting all the function calling
  var globalConfig = typeof window === 'object' && window.crossimageConfig || {};
  var params = Object.assign({
    clean: true,
    alpha: true
  }, globalConfig, config);

  // check if webp can be used
  if (!params.format) {
    if (isSupportWebp()) params.format = 'webp';
    if (isSupportAvif()) params.format = 'avif';
  }
  if (!params.size) {
    params.size = getSize(width, height, params);
  }
  params.quality = !!params.quality ? params.quality : getQuality();
  params.sharpen = !!params.sharpen ? params.sharpen : getSharpen(params.quality);
  return getUrl(url, params);
}
function getFitUrl(url, width, height, config) {
  if (width === void 0) {
    width = 0;
  }
  if (height === void 0) {
    height = 0;
  }
  if (config === void 0) {
    config = {};
  }
  var rewritedUrl = urlRewrite(url);
  if (!ARISE_DOMAIN_REFG.test(rewritedUrl)) return rewritedUrl;
  if (FILE_EXTENSION_EXCLUDE_RESIZE_REG.test(rewritedUrl)) return rewritedUrl;
  return getResizeUrl(rewritedUrl.split('?')[0].split('#')[0], width, height, config);
}
export default {
  getFitUrl: getFitUrl
};